import { Avatar } from 'element-ui'
import Vue from 'vue'

/** 
 * v-has
 * @param []
 * 数组最后一个选项为菜单级别(0)或者按钮级别(2)
 */
const has = Vue.directive('has', {
    bind: (el, binding, vnode) => {
        const level = binding.value.splice(binding.value.length - 1, 1)
        let btnPermissions
            //获取菜单权限 菜单普通用户可以有，管理员也可以有
            //获取按钮权限验证 按钮，普通用户不一定有，管理员可以有
        btnPermissions = level == 0 ? binding.value : vnode.context.$route.meta.btnPermission
        if (!Vue.prototype.$has(btnPermissions, vnode.context)) {
            vnode.context.$nextTick(() => {
                el.parentNode.removeChild(el)
            })
        }
    }
})

/**
 * v-sman
 * 是否为业务员
 */
const sman = Vue.directive('sman', {
    bind: (el, binding, vnode) => {
        const sman_level = binding.value
        if (Vue.prototype.$sman(sman_level, vnode.context)) {
            vnode.context.$nextTick(() => {
                el.parentNode.removeChild(el)
            })
        }
    }
})

Vue.prototype.$sman = (value, context) => {
    let exist = false
    let permission = context.$store.state.user.salesman
    if (permission == null || permission == undefined) {
        exist = false
    }
    if (value.some((cb) => permission == cb)) {
        exist = true
    }
    return exist
}

Vue.prototype.$has = (value, context) => {
    let isExist = false
    let btnPermission = context.$store.state.user.roles
    if (btnPermission == null || btnPermission == undefined) {
        isExist = false
    }
    if (value.some((cb) => btnPermission.includes(cb))) {
        isExist = true
    }
    return isExist
}

export { has, sman }